export default {
  methods: {
    getProviders (admin = false) {
      return this.$http.get(this.apiUrl('/providers'), admin).then((resp) => {
        return this.processSuccess(resp)
      })
    },

    sortProviders () {
      this.providers = this.providers.sort((a, b) => {
        const aTitle = a.title.toUpperCase()
        const bTitle = b.title.toUpperCase()
        if (aTitle < bTitle) {
          return -1
        } else if (bTitle > aTitle) {
          return 1
        }

        return 0
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ProvidersMixin.js